const routes = {
  websites: '/websites',
  login: '/login',
  signup: '/signup',
  resetPassword: '/reset-password',
  oneTimeVerification: '/otp',
  operators: '/operators',
  conversations: '/conversations',
  blacklist: '/blacklist',
  gatewayReport: '/payment/gateway-report',
  paymentPage: '/payment/:paymentPage',
  packageUpgrade: '/payment/package-upgrading',
  conversationsChagrge: '/payment/conversation-charging',
  bills: '/payment/bills',
  reports: '/reports/:reportId',
  reportDetails: '/reports/:reportId/:operatorId',
  conversationsReport: '/reports/conversations',
  operatorsReport: '/reports/operators',
  platformsReport: '/reports/platforms',
  usersReport: '/reports/users-statistics',
  connectWhatsapp: '/connect-whatsapp',
  settingsTeam: '/settings-team',
  groupMessage: '/group-message',
  widgetInstallation: '/widget-installation',
  costumerSuccess: '/reports/customer-success',
  teams: '/teams',
  webhook: '/webhook/:id?',
  webhookList: '/webhook',
  addWebhook: '/webhook/add',
  // profile: '/profile',

  // TODO: fix route
  settingsWidget: '/settings/:tabId/:messageId?', // TODO
  faq: '/faq/:channelId?/:faqId?',
  faqList: '/faq',
  addFaq: '/faq/add',
  // conversationsArchive: '/conversations-archive/:archivePage/:id',
  conversationsArchiveList: '/conversations-archive/all',
  userDetailsConvArchive: '/conversations-archive/user/:conversationId',
  userVisitsArchive: '/reports/users-archive',
  // profile: '/profile'
  knowledgeBasePage: '/faq-customization',
  appsList: '/apps',
  affiliatePage: '/affiliation',
};

export default routes;
